import { useUserContext } from "../../user/contexts/user.context";
import { useState, useEffect } from "react";
import { SiteWithPhotoModel } from "../models/site-with-photo.model";

export const useSitePhotoUri = (site: SiteWithPhotoModel) => {
  const { currentOrganization } = useUserContext();
  const [photoURI, changePhotoURI] = useState(() => {
    if (!currentOrganization) return site.getDefaultPhotoUri();
    return site.getPhotoUri(currentOrganization.code);
  });
  
  // Mettre à jour l'URI si l'organisation change
  useEffect(() => {
    if (currentOrganization) {
      changePhotoURI(site.getPhotoUri(currentOrganization.code));
    }
  }, [currentOrganization, site]);

  const handlerImageError = () => {
    changePhotoURI(site.getDefaultPhotoUri());
  };

  return {
    photoURI,
    handlerImageError,
  };
};
